//import "babel-polyfill";
import "slick-carousel";
import "jquery-mousewheel";
import "malihu-custom-scrollbar-plugin";

import "./libs/jcf";
import "./libs/jcf.select";
import "./libs/jcf.scrollable";
import "./libs/sticky-kit";

import { pageLoad } from "./modules/pageLoad";
import { noDev } from "./modules/noDev";
import { mainNav } from "./modules/mainNav";
import { linksSection } from "./modules/linksSection";
import { sidebarLinks } from "./modules/sidebarLinks";
import { headerSearch } from "./modules/headerSearch";
import { accordion } from "./modules/accordion";
import { blockquoteSlider } from "./modules/blockquoteSlider";
import { tabs } from "./modules/tabs";
import { popups } from "./modules/popups";
import { coloredTabs } from "./modules/coloredTabs";
import { svgMaps } from "./modules/svgMaps";
import { customSelect } from "./modules/customSelect";
import { fileUploading } from "./modules/fileUploading";
import { cardSlider } from "./modules/cardSlider";
import { regionSlider } from "./modules/regionSlider";
import { topSlider } from "./modules/topSlider";
import { fully } from "./modules/fully";
import { toTop } from "./modules/toTop";
import { customScroll } from "./modules/customScroll";
import { preloader } from "./modules/preloader";
import { confirmation } from "./modules/confirmation";
import { submitSiteAnchors } from "./modules/submitSiteAnchors";
import { stickySidebar } from "./modules/stickySidebar";
import { validation } from "./modules/validation";
import { langSwitcher } from "./modules/langSwitcher";
import { sliderBusinessSupport } from "./modules/sliderBusinessSupport";

import binder from "./libs/binder";
import {
  staticFunctions,
  constants,
  commonFunction,
  anotherCommonFunction,
} from "./modules/module";

binder({
  bounds: {
    "html": [constants, staticFunctions, noDev, popups, confirmation],
    "body": [commonFunction, anotherCommonFunction, coloredTabs, preloader, pageLoad],
    ".header_": [mainNav, headerSearch],
    ".links-section": linksSection,
    ".sidebar": sidebarLinks,
    ".accordion": accordion,
    ".blockquote-slider": blockquoteSlider,
    ".district-map": svgMaps,
    "select": customSelect,
    "form": fileUploading,
    ".card-slider": cardSlider,
    ".region-slider": regionSlider,
    ".top-slider": topSlider,
    ".home-page": fully,
    ".scrollable": customScroll,
    ".footer_ .to-top-btn": toTop,
    ".submit-site-sidebar": [stickySidebar, submitSiteAnchors],
    ".tabs": tabs,
    ".wpcf7": validation,
    ".lang-switcher": langSwitcher,
      ".slick-slide": sliderBusinessSupport
  },
  runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js